export default __webpack_public_path__ + "static/media/panel-bg-light.425ed461.png";